import ClassifyInput from "@/widgets/Inputs/ClassifyInput.vue";

export default {
	components: {
		ClassifyInput
	},
	data() {
		return {
			filterClassify: []
		};
	},
	watch: {
		filterClassify: {
			handler(val) {
				let fieldName = "classify._id";
				if (this.filterClassify.length > 0) {
					this.$set(this.kvFilter, fieldName, {
						k: fieldName,
						t: "id",
						v: this.filterClassify[this.filterClassify.length - 1]._id
					});
				} else {
					this.$delete(this.kvFilter, fieldName);
				}
			},
			immediate: true,
			deep: true
		}
	}
};
